import { useEffect, useState } from "react";
import { View, Text, Image } from "react-native";
import { useTranslations } from "@src/packages/i18n";
import { EMBER } from "../../../../onboarding/theme";
import {
  Dialog,
  DialogPrimaryButton,
  SoftSecondaryButton,
} from "@louise/moon-ui";

const doorIcon =
  require("../../../../assets/images/you-icons/door-arch.png") as number;
type Props = {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
};

export default function LogoutModal({ visible, onClose, onConfirm }: Props) {
  const t = useTranslations();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  useEffect(() => {
    if (!visible) setIsLoggingOut(false);
  }, [visible]);

  const handleConfirm = async () => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);
    await onConfirm();
  };

  return (
    <Dialog visible={visible} onClose={onClose} layout="centered">
      <Image
        source={doorIcon}
        style={{ width: 80, height: 96, alignSelf: "center" }}
        resizeMode="contain"
      />
      <Text
        accessibilityRole="header"
        className="font-dm-sans"
        style={{
          fontSize: 20,
          fontWeight: "700",
          color: EMBER.colors.text,
          textAlign: "center",
          marginTop: 16,
          marginBottom: 8,
        }}
      >
        {t("you.modals.logout.title")}
      </Text>
      <Text
        className="font-dm-sans"
        style={{
          fontSize: 14,
          color: EMBER.colors.textLight,
          textAlign: "center",
          lineHeight: 20,
          marginBottom: 24,
        }}
      >
        {t("you.modals.logout.message")}
      </Text>

      <View style={{ flexDirection: "row", gap: 12 }}>
        <SoftSecondaryButton
          label={t("you.modals.logout.cancel")}
          onPress={onClose}
          flex={1}
        />
        <DialogPrimaryButton
          label={t("you.modals.logout.confirm")}
          onPress={() => void handleConfirm()}
          loading={isLoggingOut}
          disabled={isLoggingOut}
          flex={1.5}
        />
      </View>
    </Dialog>
  );
}
